import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { ArrowLeftOutlined, UndoOutlined, SaveOutlined } from '@ant-design/icons';

import { Button, Row, Col, Typography, Radio } from 'antd';
import treeChanges from 'tree-changes';
import {
  FormikInput,
  FormikText,
  FormikRadio,
  FormikButton,
  FormikSelect
} from '../../Components/Formik';
import DeliveryPointDetailActions from '../../Stores/DeliveryPointDetail/Actions';
import AppActions from '../../Stores/App/Actions';

const { Text } = Typography;

class ModelForm extends React.PureComponent {
  constructor() {
    super();

    this.handleSearchDebtorGroup01 = this.handleSearchDebtorGroup01.bind(this);
    this.handleSearchDebtorGroup02 = this.handleSearchDebtorGroup02.bind(this);
    this.handleSearchDebtorGroup03 = this.handleSearchDebtorGroup03.bind(this);
    this.handleSearchArea = this.handleSearchArea.bind(this);
  }

  componentDidMount() {
    const { resId, resetTimestamp } = this.props;

    if (resId > 0) {
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const { match, resId, resetTimestamp, initModel, showModel } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('resId')) {
      resetTimestamp();
    }
    if (changed('timestamp')) {
      if (resId <= 0) {
        initModel(match.params.id);
      } else {
        showModel(resId);
      }
    }
  }

  componentWillUnmount() {}

  handleSearchDebtorGroup01(form, value) {
    const { fetchDebtorGroup01Options } = this.props;

    fetchDebtorGroup01Options(value);
  }

  handleSearchDebtorGroup02(form, value) {
    const { fetchDebtorGroup02Options } = this.props;

    fetchDebtorGroup02Options(value);
  }

  handleSearchDebtorGroup03(form, value) {
    const { fetchDebtorGroup03Options } = this.props;

    fetchDebtorGroup03Options(value);
  }

  handleSearchArea(form, value) {
    const { fetchAreaOptions } = this.props;

    fetchAreaOptions(value);
  }

  render() {
    const {
      intl,
      match,
      model,
      createModel,
      updateModel,
      historyGoBack,
      modelIsLoading,
      debtorGroup01IsLoading,
      debtorGroup01Options,
      debtorGroup02IsLoading,
      debtorGroup02Options,
      debtorGroup03IsLoading,
      debtorGroup03Options,
      areaIsLoading,
      areaOptions
    } = this.props;

    const statusOptions = [
      <Radio.Button key={1} value={1}>
        {intl.formatMessage({ id: 'DELETED' })}
      </Radio.Button>,
      <Radio.Button key={2} value={2}>
        {intl.formatMessage({ id: 'INACTIVE' })}
      </Radio.Button>,
      <Radio.Button key={3} value={3}>
        {intl.formatMessage({ id: 'BLOCKED' })}
      </Radio.Button>,
      <Radio.Button key={4} value={4}>
        {intl.formatMessage({ id: 'CONFLICT' })}
      </Radio.Button>,
      <Radio.Button key={5} value={5}>
        {intl.formatMessage({ id: 'NEW' })}
      </Radio.Button>,
      <Radio.Button key={50} value={50}>
        {intl.formatMessage({ id: 'WIP' })}
      </Radio.Button>,
      <Radio.Button key={100} value={100}>
        {intl.formatMessage({ id: 'ACTIVE' })}
      </Radio.Button>
    ];

    const disabled = false;

    return (
      <Formik
        enableReinitialize
        initialValues={model}
        onSubmit={(values, formikBag) => {
          if (match.params.action === 'create') {
            createModel(formikBag, values);
          } else {
            updateModel(formikBag, values);
          }
        }}
        validationSchema={Yup.object().shape({
          debtor_code: Yup.string().required(intl.formatMessage({ id: 'code_is_required' })),
          code: Yup.string().required(intl.formatMessage({ id: 'code_is_required' })),
          company_name_01: Yup.string().required(intl.formatMessage({ id: 'name_is_required' })),
          debtor_group_01_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'category_is_required' }))
          }),
          debtor_group_02_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'chain_is_required' }))
          }),
          debtor_group_03_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'channel_is_required' }))
          }),
          area_select2: Yup.object().shape({
            value: Yup.number().min(1, intl.formatMessage({ id: 'area_is_required' }))
          }),
          status: Yup.number().min(1, intl.formatMessage({ id: 'status_is_required' }))
        })}
      >
        {({
          // values,
          // handleChange,
          // errors,
          // setFieldTouched,
          dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit,
          handleReset
        }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'principal_or_debtor' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_code"
                  component={FormikText}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'code' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field name="code" component={FormikInput} disabled={disabled || modelIsLoading} />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'status' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="status"
                  component={FormikRadio}
                  options={statusOptions}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'ref_code' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={10}>
                <Field
                  name="ref_code_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
              <Col span={10}>
                <Field
                  name="ref_code_02"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'name' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="company_name_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3} />
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="company_name_02"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'category' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_group_01_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDebtorGroup01}
                  notFoundContent={null}
                  loading={debtorGroup01IsLoading}
                  options={debtorGroup01Options}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'chain' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_group_02_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDebtorGroup02}
                  notFoundContent={null}
                  loading={debtorGroup02IsLoading}
                  options={debtorGroup02Options}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'channel' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_group_03_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDebtorGroup03}
                  notFoundContent={null}
                  loading={debtorGroup03IsLoading}
                  options={debtorGroup03Options}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'area' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="area_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchArea}
                  notFoundContent={null}
                  loading={areaIsLoading}
                  options={areaOptions}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'unit_no' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="unit_no"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'building_name' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="building_name"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'street_name' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="street_name"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'district_01' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="district_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'district_02' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="district_02"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'postcode' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="postcode"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'state_name' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="state_name"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'country_name' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="country_name"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'attention' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="attention"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'phone' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={10}>
                <Field
                  name="phone_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
              <Col span={10}>
                <Field
                  name="phone_02"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'fax' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={10}>
                <Field
                  name="fax_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
              <Col span={10}>
                <Field
                  name="fax_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'email' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={10}>
                <Field
                  name="email_01"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
              <Col span={10}>
                <Field
                  name="email_02"
                  component={FormikInput}
                  disabled={disabled || modelIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[0, 16]}>
              <Col span={8}>
                <Button
                  type="primary"
                  // disabled={!isValid}
                  loading={isSubmitting}
                  onClick={historyGoBack}
                  icon={<ArrowLeftOutlined />}
                >
                  {intl.formatMessage({
                    id: 'back'
                  })}
                </Button>
              </Col>
              <Col span={5}>
                <Button
                  type="primary"
                  disabled={!dirty}
                  loading={isSubmitting || modelIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>
                <Field
                  name="submit_action"
                  type="primary"
                  value="update"
                  component={FormikButton}
                  // disabled={values.status >= 50}
                  loading={isSubmitting || modelIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({
                    id: match.params.action === 'create' ? 'create' : 'update'
                  })}
                  icon={<SaveOutlined />}
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

ModelForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  resetTimestamp: PropTypes.func,

  initModel: PropTypes.func,
  showModel: PropTypes.func,
  createModel: PropTypes.func,
  updateModel: PropTypes.func,
  historyGoBack: PropTypes.func,
  resId: PropTypes.number,
  model: PropTypes.shape({
    status: PropTypes.number
  }),
  modelIsLoading: PropTypes.bool,

  fetchDebtorGroup01Options: PropTypes.func,
  debtorGroup01IsLoading: PropTypes.bool,
  debtorGroup01Options: PropTypes.arrayOf(PropTypes.object),

  fetchDebtorGroup02Options: PropTypes.func,
  debtorGroup02IsLoading: PropTypes.bool,
  debtorGroup02Options: PropTypes.arrayOf(PropTypes.object),

  fetchDebtorGroup03Options: PropTypes.func,
  debtorGroup03IsLoading: PropTypes.bool,
  debtorGroup03Options: PropTypes.arrayOf(PropTypes.object),

  fetchAreaOptions: PropTypes.func,
  areaIsLoading: PropTypes.bool,
  areaOptions: PropTypes.arrayOf(PropTypes.object)
};

ModelForm.defaultProps = {
  intl: {},
  match: {},
  resetTimestamp() {},

  initModel() {},
  showModel() {},
  createModel() {},
  updateModel() {},
  historyGoBack() {},
  resId: 0,
  model: { status: 2 },
  modelIsLoading: false,

  fetchDebtorGroup01Options() {},
  debtorGroup01IsLoading: false,
  debtorGroup01Options: [],

  fetchDebtorGroup02Options() {},
  debtorGroup02IsLoading: false,
  debtorGroup02Options: [],

  fetchDebtorGroup03Options() {},
  debtorGroup03IsLoading: false,
  debtorGroup03Options: [],

  fetchAreaOptions() {},
  areaIsLoading: false,
  areaOptions: []
};

const mapStateToProps = state => ({
  apiUrl: state.app.apiUrl,
  timestamp: state.deliveryPointDetail.modelTimestamp,
  resId: state.deliveryPointDetail.resId,
  model: state.deliveryPointDetail.model,
  modelIsLoading: state.deliveryPointDetail.modelIsLoading,

  debtorGroup01IsLoading: state.deliveryPointDetail.debtorGroup01IsLoading,
  debtorGroup01Options: state.deliveryPointDetail.debtorGroup01Options,

  debtorGroup02IsLoading: state.deliveryPointDetail.debtorGroup02IsLoading,
  debtorGroup02Options: state.deliveryPointDetail.debtorGroup02Options,

  debtorGroup03IsLoading: state.deliveryPointDetail.debtorGroup03IsLoading,
  debtorGroup03Options: state.deliveryPointDetail.debtorGroup03Options,

  areaIsLoading: state.deliveryPointDetail.areaIsLoading,
  areaOptions: state.deliveryPointDetail.areaOptions
});

const mapDispatchToProps = dispatch => ({
  resetTimestamp: () =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailResetModelTimestamp()),
  initModel: debtorId =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailInitModel(debtorId)),
  showModel: resId => dispatch(DeliveryPointDetailActions.deliveryPointDetailShowModel(resId)),

  updateModel: (formikBag, model) =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailUpdateModel(formikBag, model)),
  createModel: (formikBag, model) =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailCreateModel(formikBag, model)),

  fetchDebtorGroup01Options: search =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailFetchDebtorGroup01Options(search)),
  fetchDebtorGroup02Options: search =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailFetchDebtorGroup02Options(search)),
  fetchDebtorGroup03Options: search =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailFetchDebtorGroup03Options(search)),

  fetchAreaOptions: search =>
    dispatch(DeliveryPointDetailActions.deliveryPointDetailFetchAreaOptions(search)),

  historyGoBack: () => dispatch(AppActions.appHistoryGoBack())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ModelForm));
